import { useEffect } from "react";
import { useNavigate, useRouterState } from "@tanstack/react-router";
import { useAuth } from "./AuthContext";

export function RequireAuth({
  children,
  adminOnly = false,
}: {
  children: React.ReactNode;
  adminOnly?: boolean;
}) {
  const { session, isAdmin, loading } = useAuth();
  const navigate = useNavigate();
  const path = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    if (loading) return;
    if (!session) {
      navigate({ to: "/login", search: { redirect: path } as any });
      return;
    }
    if (adminOnly && !isAdmin) {
      navigate({ to: "/dashboard" });
    }
  }, [loading, session, isAdmin, adminOnly, navigate, path]);

  if (loading || !session || (adminOnly && !isAdmin)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="font-mono text-xs text-muted-foreground tracking-[0.3em]">
          AUTHENTICATING…
        </div>
      </div>
    );
  }
  return <>{children}</>;
}